// @flow
import * as React from 'react';
import ApiForm from 'esm-web-pro/containers/forms/ApiForm';
import type { UUID } from 'esm-web-pro/types/common';
import { MapContext } from 'esm-web-pro/containers/map/context';


type Props = {
    model: string,
    // Specify either a single object id or multiple ids to which
    // the document should be attached
    id?: UUID,
    ids?: UUID[],
    onSave: Function,
    onClose: Function,
};

const InfrastructureDocumentPermitForm = (props: Props) => {
    const {
        model, id, onSave, onClose, ids,
    } = props;

    const map = React.useContext(MapContext);

    const handleSubmit = (values) => {
        const { file } = values;
        values.files = { file };
        delete values.file;

        if (ids?.length) {
            return ids.map((uuid) => ({
                object_ct: JSON.stringify({
                    app_label: 'networks',
                    model,
                }),
                object_id: uuid,
                map: map.uuid,
                ...values,
            }));
        }
        return {
            ...values,
            object_ct: JSON.stringify({
                app_label: 'networks',
                model,
            }),
            object_id: id,
            map: map.uuid,
        };
    };

    return (
        <ApiForm
            key="infrastructure-document-permit"
            resourceName="infrastructureDocumentPermit"
            excludeFields={['object_id', 'object_ct', 'map']}
            height="100%"
            onClose={onClose}
            onSave={onSave}
            onSubmit={handleSubmit}
        />
    );
};

InfrastructureDocumentPermitForm.defaultProps = {
    ids: [],
    id: '',
};

export default InfrastructureDocumentPermitForm;
